import { Theme } from './theme.interface';
import { Layout } from '@graphql/types';
import { newThemeNames } from './newThemes';

const midnightPeony = require('./config/midnightPeony.json');
const bohemianFloral = require('./config/bohemianFloral.json');
const dreamWash = require('./config/dreamWash.json');
const mutedFloral = require('./config/mutedFloral.json');
const formalAmpersand = require('./config/formalAmpersand.json');
const porcelainBreeze = require('./config/porcelainBreeze.json');
const darkThorn = require('./config/darkThorn.json');
const vintageFlowers = require('./config/vintageFlowers.json');
const elegantEucalyptus = require('./config/elegantEucalyptus.json');
const naturalLaurel = require('./config/naturalLaurel.json');
const calligraphicBotanical = require('./config/calligraphicBotanical.json');
const fernBotanical = require('./config/fernBotanical.json');
const lavendarYard = require('./config/lavendarYard.json');
const lushGreenery = require('./config/lushGreenery.json');
const paintedWinery = require('./config/paintedWinery.json');
const painterlyBloomsOne = require('./config/painterlyBloomsOne.json');
const painterlyBloomsTwo = require('./config/painterlyBloomsTwo.json');
const painterlyBohemian = require('./config/painterlyBohemian.json');
const romanticGarland = require('./config/romanticGarland.json');
const romanticSucculents = require('./config/romanticSucculents.json');
const rusticElegance = require('./config/rusticElegance.json');
const rusticWreath = require('./config/rusticWreath.json');
const painterlyGem = require('./config/painterlyGem.json');
const watercolorCactus = require('./config/watercolorCactus.json');
const modernBrushstrokes = require('./config/modernBrushstrokes.json');
const modernMarble = require('./config/modernMarble.json');
const paintedPink = require('./config/paintedPink.json');
const alpineWreath = require('./config/alpineWreath.json');
const antiqueLily = require('./config/antiqueLily.json');
const blushMutedFloral = require('./config/blushMutedFloral.json');
const branchingOut = require('./config/branchingOut.json');
const bridechillaConfetti = require('./config/bridechillaConfetti.json');
const bridechillaRainbows = require('./config/bridechillaRainbows.json');
const bridechillaTriangles = require('./config/bridechillaTriangles.json');
const brightBotanical = require('./config/brightBotanical.json');
const bronzeFloralFrame = require('./config/bronzeFloralFrame.json');
const bronzedLeaves = require('./config/bronzedLeaves.json');
const bubbleGum = require('./config/bubbleGum.json');
const captainWarrenAbdul = require('./config/captainWarrenAbdul.json');
const chandelier = require('./config/chandelier.json');
const classicLinen = require('./config/classicLinen.json');
const classico = require('./config/classico.json');
const cosmicNight = require('./config/cosmicNight.json');
const cottonCandy = require('./config/cottonCandy.json');
const crystalDusk = require('./config/crystalDusk.json');
const earthlyOrganic = require('./config/earthlyOrganic.json');
const edgyCurtain = require('./config/edgyCurtain.json');
const elegance = require('./config/elegance.json');
const elegantIndustrial = require('./config/elegantIndustrial.json');
const elegantOasis = require('./config/elegantOasis.json');
const elegantPaper = require('./config/elegantPaper.json');
const elegantParadise = require('./config/elegantParadise.json');
const endlessTime = require('./config/endlessTime.json');
const fallingLeaves = require('./config/fallingLeaves.json');
const fancyCurtain = require('./config/fancyCurtain.json');
const fionasFlowers = require('./config/fionasFlowers.json');
const firstJasmine = require('./config/firstJasmine.json');
const floralBouquet = require('./config/floralBouquet.json');
const floralLace = require('./config/floralLace.json');
const goldVines = require('./config/goldVines.json');
const graphite = require('./config/graphite.json');
const illustratedBook = require('./config/illustratedBook.json');
const lavenderSage = require('./config/lavenderSage.json');
const lightSnow = require('./config/lightSnow.json');
const lovebirds = require('./config/lovebirds.json');
const marrakech = require('./config/marrakech.json');
const metallicWreath = require('./config/metallicWreath.json');
const midnight = require('./config/midnight.json');
const modMarble = require('./config/modMarble.json');
const modernBohemian = require('./config/modernBohemian.json');
const modernBranches = require('./config/modernBranches.json');
const mountBaker = require('./config/mountBaker.json');
const newYorkLights = require('./config/newYorkLights.json');
const northwest = require('./config/northwest.json');
const sanFrancisco = require('./config/sanFrancisco.json');
const seaSalt = require('./config/seaSalt.json');
const simpleRustic = require('./config/simpleRustic.json');
const springFlowers = require('./config/springFlowers.json');
const springPink = require('./config/springPink.json');
const starGazing = require('./config/starGazing.json');
const strungLights = require('./config/strungLights.json');
const summerLinen = require('./config/summerLinen.json');
const toran = require('./config/toran.json');
const vintageMountain = require('./config/vintageMountain.json');
const vintageSunset = require('./config/vintageSunset.json');
const watercolorBeach = require('./config/watercolorBeach.json');
const watercolorBeachTwo = require('./config/watercolorBeachTwo.json');
const weDo = require('./config/weDo.json');
const wonderferris = require('./config/wonderferris.json');
const woodgrainLace = require('./config/woodgrainLace.json');
const woodgrainLaceWood = require('./config/woodgrainLaceWood.json');
const woodsyWreath = require('./config/woodsyWreath.json');
const zenFlower = require('./config/zenFlower.json');
const palace = require('./config/palace.json');
const papelPicado = require('./config/papelPicado.json');
const queensPalace = require('./config/queensPalace.json');
const raspberrySherbet = require('./config/raspberrySherbet.json');
const roseSunset = require('./config/roseSunset.json');
const cascadingAltar = require('./config/cascadingAltar.json');
const blank = require('./config/blank.json');
// const victorian = require('./config/victorian.json');
const eucalyptus = require('./config/eucalyptus.json');
const gardenEstate = require('./config/gardenEstate.json');
const goldenNative = require('./config/goldenNative.json');
const laButte = require('./config/laButte.json');
const rosey = require('./config/rosey.json');
const bluemchen = require('./config/bluemchen.json');
const botanicalGeo = require('./config/botanicalGeo.json');
const blueContour = require('./config/blueContour.json');
const gardenWindow = require('./config/gardenWindow.json');
const whiteGarden = require('./config/whiteGarden.json');
const rusticFloral = require('./config/rusticFloral.json');
const snowLake = require('./config/snowLake.json');
const sand = require('./config/sand.json');
const ivory = require('./config/ivory.json');
const blush = require('./config/blush.json');
const creme = require('./config/creme.json');

const alohaSwitch = (themeName: string) => {
  let theme: Theme;
  switch (themeName) {
    case 'blank':
      theme = blank;
      break;
    case 'midnight_peony':
      theme = midnightPeony;
      break;
    case 'bohemian_floral':
      theme = bohemianFloral;
      break;
    case 'dream_wash':
      theme = dreamWash;
      break;
    case 'muted_floral':
      theme = mutedFloral;
      break;
    case 'formal_ampersand':
      theme = formalAmpersand;
      break;
    case 'porcelain_breeze':
      theme = porcelainBreeze;
      break;
    case 'dark_thorn':
      theme = darkThorn;
      break;
    case 'vintage_flowers':
      theme = vintageFlowers;
      break;
    case 'elegant_eucalyptus':
      theme = elegantEucalyptus;
      break;
    case 'natural_laurel':
      theme = naturalLaurel;
      break;
    case 'calligraphic_botanical':
      theme = calligraphicBotanical;
      break;
    case 'fern_botanical':
      theme = fernBotanical;
      break;
    case 'lavendar_yard':
      theme = lavendarYard;
      break;
    case 'lush_greenery':
      theme = lushGreenery;
      break;
    case 'painted_winery':
      theme = paintedWinery;
      break;
    case 'painterly_blooms_one':
      theme = painterlyBloomsOne;
      break;
    case 'painterly_blooms_two':
      theme = painterlyBloomsTwo;
      break;
    case 'painterly_bohemian':
      theme = painterlyBohemian;
      break;
    case 'romantic_garland':
      theme = romanticGarland;
      break;
    case 'romantic_succulents':
      theme = romanticSucculents;
      break;
    case 'rustic_elegance':
      theme = rusticElegance;
      break;
    case 'rustic_wreath':
      theme = rusticWreath;
      break;
    case 'painterly_gem':
      theme = painterlyGem;
      break;
    case 'watercolor_cactus':
      theme = watercolorCactus;
      break;
    case 'modern_brushstrokes':
      theme = modernBrushstrokes;
      break;
    case 'modern_marble':
      theme = modernMarble;
      break;
    case 'painted_pink':
      theme = paintedPink;
      break;
    case 'wreath':
      theme = alpineWreath;
      break;
    case 'antique_lily':
      theme = antiqueLily;
      break;
    case 'blush_muted_floral':
      theme = blushMutedFloral;
      break;
    case 'branching_out':
      theme = branchingOut;
      break;
    case 'bridechilla_confetti':
      theme = bridechillaConfetti;
      break;
    case 'bridechilla_rainbows':
      theme = bridechillaRainbows;
      break;
    case 'bridechilla_triangles':
      theme = bridechillaTriangles;
      break;
    case 'bright_botanical':
      theme = brightBotanical;
      break;
    case 'bronze_floral_frame':
      theme = bronzeFloralFrame;
      break;
    case 'bronzed_leaves':
      theme = bronzedLeaves;
      break;
    case 'bubble_gum':
      theme = bubbleGum;
      break;
    case 'captain_warren_abdul':
      theme = captainWarrenAbdul;
      break;
    case 'cascading_altar':
      theme = cascadingAltar;
      break;
    case 'chandelier':
      theme = chandelier;
      break;
    case 'classic_linen':
      theme = classicLinen;
      break;
    case 'classico':
      theme = classico;
      break;
    case 'cosmic_night':
      theme = cosmicNight;
      break;
    case 'cotton_candy':
      theme = cottonCandy;
      break;
    case 'crystal_dusk':
      theme = crystalDusk;
      break;
    case 'earthly_organic':
      theme = earthlyOrganic;
      break;
    case 'edgy_curtain':
      theme = edgyCurtain;
      break;
    case 'elegance':
      theme = elegance;
      break;
    case 'elegant_industrial':
      theme = elegantIndustrial;
      break;
    case 'elegant_oasis':
      theme = elegantOasis;
      break;
    case 'elegant_paper':
      theme = elegantPaper;
      break;
    case 'elegant_paradise':
      theme = elegantParadise;
      break;
    case 'endless_time':
      theme = endlessTime;
      break;
    case 'falling_leaves':
      theme = fallingLeaves;
      break;
    case 'fancy_curtain':
      theme = fancyCurtain;
      break;
    case 'fionas_flowers':
      theme = fionasFlowers;
      break;
    case 'first_jasmine':
      theme = firstJasmine;
      break;
    case 'floral_bouquet':
      theme = floralBouquet;
      break;
    case 'floral_lace':
      theme = floralLace;
      break;
    case 'gold_vines':
      theme = goldVines;
      break;
    case 'graphite':
      theme = graphite;
      break;
    case 'illustrated_book':
      theme = illustratedBook;
      break;
    case 'lavender_sage':
      theme = lavenderSage;
      break;
    case 'light_snow':
      theme = lightSnow;
      break;
    case 'lovebirds':
      theme = lovebirds;
      break;
    case 'marrakech':
      theme = marrakech;
      break;
    case 'metallic_wreath':
      theme = metallicWreath;
      break;
    case 'midnight':
      theme = midnight;
      break;
    case 'mod_marble':
      theme = modMarble;
      break;
    case 'modern_bohemian':
      theme = modernBohemian;
      break;
    case 'modern_branches':
      theme = modernBranches;
      break;
    case 'mount_baker':
      theme = mountBaker;
      break;
    case 'new_york_lights':
      theme = newYorkLights;
      break;
    case 'northwest':
      theme = northwest;
      break;
    case 'san_francisco':
      theme = sanFrancisco;
      break;
    case 'sea_salt':
      theme = seaSalt;
      break;
    case 'simple_rustic':
      theme = simpleRustic;
      break;
    case 'spring_flowers':
      theme = springFlowers;
      break;
    case 'spring_pink':
      theme = springPink;
      break;
    case 'star_gazing':
      theme = starGazing;
      break;
    case 'strung_lights':
      theme = strungLights;
      break;
    case 'summer_linen':
      theme = summerLinen;
      break;
    case 'toran':
      theme = toran;
      break;
    case 'vintage_mountain':
      theme = vintageMountain;
      break;
    case 'vintage_sunset':
      theme = vintageSunset;
      break;
    case 'watercolor_beach':
      theme = watercolorBeach;
      break;
    case 'watercolor_beach_two':
      theme = watercolorBeachTwo;
      break;
    case 'we_do':
      theme = weDo;
      break;
    case 'wonderferris':
      theme = wonderferris;
      break;
    case 'woodgrain_lace':
      theme = woodgrainLace;
      break;
    case 'woodgrain_lace_wood':
      theme = woodgrainLaceWood;
      break;
    case 'woodsy_wreath':
      theme = woodsyWreath;
      break;
    case 'zen_flower':
      theme = zenFlower;
      break;
    case 'dream_wash':
      theme = dreamWash;
      break;
    case 'palace':
      theme = palace;
      break;
    case 'papel_picado':
      theme = papelPicado;
      break;
    case 'queens_palace':
      theme = queensPalace;
      break;
    case 'raspberry_sherbet':
      theme = raspberrySherbet;
      break;
    case 'rose_sunset':
      theme = roseSunset;
      break;
    case 'cascading_altar':
      theme = cascadingAltar;
      break;
    // case 'victorian':
    //   theme = victorian; break;
    case 'eucalyptus':
      theme = eucalyptus;
      break;
    case 'garden_estate':
      theme = gardenEstate;
      break;
    case 'golden_native':
      theme = goldenNative;
      break;
    case 'la_butte':
      theme = laButte;
      break;
    case 'rosey':
      theme = rosey;
      break;
    case 'bluemchen':
      theme = bluemchen;
      break;
    case 'botanical_geo':
      theme = botanicalGeo;
      break;
    case 'blue_contour':
      theme = blueContour;
      break;
    case 'garden_window':
      theme = gardenWindow;
      break;
    case 'white_garden':
      theme = whiteGarden;
      break;
    case 'rustic_floral':
      theme = rusticFloral;
      break;
    case 'snow_lake':
      theme = snowLake;
      break;
    case 'sand':
      theme = sand;
      break;
    case 'ivory':
      theme = ivory;
      break;
    case 'blush':
      theme = blush;
      break;
    case 'creme':
      theme = creme;
      break;
    default:
      theme = blank;
      break;
  }

  return theme;
};

const brannanSwitch = (themeName: string): Theme => {
  switch (themeName) {
    case 'blank':
      return blank;
    case 'blue_contour':
      return blueContour;
    case 'bluemchen':
      return bluemchen;
    case 'blush':
      return blush;
    case 'blush_muted_floral':
      return blushMutedFloral;
    case 'bohemian_floral':
      return bohemianFloral;
    case 'botanical_geo':
      return botanicalGeo;
    case 'branching_out':
      return branchingOut;
    case 'bronze_floral_frame':
      return bronzeFloralFrame;
    case 'bronzed_leaves':
      return bronzedLeaves;
    case 'calligraphic_botanical':
      return calligraphicBotanical;
    case 'cascading_altar':
      return cascadingAltar;
    case 'classic_linen':
      return classicLinen;
    case 'cosmic_night':
      return cosmicNight;
    case 'cotton_candy':
      return cottonCandy;
    case 'creme':
      return creme;
    case 'dark_thorn':
      return darkThorn;
    case 'dream_wash':
      return dreamWash;
    case 'earthly_organic':
      return earthlyOrganic;
    case 'elegance':
      return elegance;
    case 'elegant_eucalyptus':
      return elegantEucalyptus;
    case 'elegant_industrial':
      return elegantIndustrial;
    case 'elegant_oasis':
      return elegantOasis;
    case 'elegant_paper':
      return elegantPaper;
    case 'eucalyptus':
      return eucalyptus;
    case 'fern_botanical':
      return fernBotanical;
    case 'floral_bouquet':
      return floralBouquet;
    case 'garden_estate':
      return gardenEstate;
    case 'garden_window':
      return gardenWindow;
    case 'gold_vines':
      return goldVines;
    case 'golden_native':
      return goldenNative;
    case 'graphite':
      return graphite;
    case 'illustrated_book':
      return illustratedBook;
    case 'ivory':
      return ivory;
    case 'la_butte':
      return laButte;
    case 'lavender_sage':
      return lavenderSage;
    case 'lush_greenery':
      return lushGreenery;
    case 'metallic_wreath':
      return metallicWreath;
    case 'midnight_peony':
      return midnightPeony;
    case 'modern_brushstrokes':
      return modernBrushstrokes;
    case 'modern_marble':
      return modernMarble;
    case 'mod_marble':
      return modMarble;
    case 'muted_floral':
      return mutedFloral;
    case 'natural_laurel':
      return naturalLaurel;
    case 'northwest':
      return northwest;
    case 'painted_pink':
      return paintedPink;
    case 'painted_winery':
      return paintedWinery;
    case 'painterly_bohemian':
      return painterlyBohemian;
    case 'painterly_gem':
      return painterlyGem;
    case 'palace':
      return palace;
    case 'porcelain_breeze':
      return porcelainBreeze;
    case 'romantic_garland':
      return romanticGarland;
    case 'romantic_succulents':
      return romanticSucculents;
    case 'rosey':
      return rosey;
    case 'rustic_elegance':
      return rusticElegance;
    case 'rustic_floral':
      return rusticFloral;
    case 'rustic_wreath':
      return rusticWreath;
    case 'sand':
      return sand;
    case 'sea_salt':
      return seaSalt;
    case 'simple_rustic':
      return simpleRustic;
    case 'snow_lake':
      return snowLake;
    case 'star_gazing':
      return starGazing;
    case 'strung_lights':
      return strungLights;
    case 'vintage_mountain':
      return vintageMountain;
    case 'watercolor_beach':
      return watercolorBeach;
    case 'watercolor_cactus':
      return watercolorCactus;
    case 'we_do':
      return weDo;
    case 'white_garden':
      return whiteGarden;
    case 'wonderferris':
      return wonderferris;
    case 'woodgrain_lace':
      return woodgrainLace;
    case 'wreath':
      return alpineWreath;
    default:
      return blank;
  }
};

export type ThemeServiceResponse = (Theme['aloha'] | Theme['brannan']) & { name: string };

function themeService(themeName: string, layout: Layout.aloha): Theme['aloha'] & { name: string };
function themeService(themeName: string, layout: Layout.brannan): Theme['brannan'] & { name: string };
function themeService(themeName: string, layout: Layout = Layout.aloha): ThemeServiceResponse {
  let theme: Theme;

  switch (layout) {
    case 'aloha':
      theme = alohaSwitch(themeName);
      return { ...theme.aloha, name: theme.name };
    case 'brannan':
      theme = brannanSwitch(themeName);
      return { ...theme.brannan, name: theme.name };
    default:
      theme = blank;
      return { ...theme.aloha, name: theme.name };
  }
}

const isValidThemeForLayout = (themeName: string, currentLayout: Layout) => {
  if (newThemeNames.includes(themeName)) {
    return true;
  }
  let themeConfig: ThemeServiceResponse | null = null;
  switch (currentLayout) {
    case Layout.aloha: {
      themeConfig = themeService(themeName, Layout.aloha);
      break;
    }
    case Layout.brannan: {
      themeConfig = themeService(themeName, Layout.brannan);
      break;
    }
    default:
      break;
  }
  return themeConfig ? themeConfig.name !== blank.name : false;
};

export { themeService, isValidThemeForLayout };
